import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CommandPaletteService {
  readonly open = signal(false);
  readonly query = signal('');

  openPalette(): void {
    this.query.set('');
    this.open.set(true);
  }

  closePalette(): void {
    this.open.set(false);
    this.query.set('');
  }

  setQuery(value: string): void {
    this.query.set(value);
  }
}
